// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__1HpKS","noInteraction":"EventWrapper_noInteraction__8E2Ql"};